import React, { Component } from "react";

import { Form, Button, Input, Checkbox, Row, Col, Spin } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import VehicleGroupStore from "../store/VehicleGroupStore";
import withRouter from "../withRouter";

import CompanyAutocomplete from "./CompanyAutocomplete";

import CompanyStore from "../store/CompanyStore";

// CHANGE: Removed unused `const CheckboxGroup = Checkbox.Group` — imported but never used

class VehicleGroupAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      // CHANGE: Removed unused `showAsset` and `isSelectAll` state — never read anywhere
      selectedChecked: false,
      selectedValues: [],
      deviceGroupId: "",
      companyId: "",
      loadingSpin: false,
      vehicleSearchArray: [],
      savedSelectedValues: [],
    };
    this.groupStore = new VehicleGroupStore();
    this.companyStore = new CompanyStore();
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      // CHANGE: Merged two separate setStates into one to avoid extra re-renders
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
        isadmin: this.props.getUserData().isadmin,
      });
      const data = await this.groupStore.getAssetData(
        {
          companyId: this.props.getUserData().userCompanyId,
          isadmin: this.props.getUserData().isadmin,
          userId: this.props.getUserData().userId,
        }
      );
      await this.setState({ vehicleSearchArray: data });
    }

    const deviceGroupId = this.props.vehicleGroupId;
    if (deviceGroupId) {
      await this.filldata(deviceGroupId);
      await this.setState({ deviceGroupId });
    }
  }

  filldata = async (deviceGroupId) => {
    await this.setState({ loadingSpin: true });

    const getVehicleGroup = await this.groupStore.getVehicleGroupData(
      deviceGroupId,
      this.props.companyId
    );

    const allVehicles = await this.groupStore.getAssetData({
      companyId: this.props.companyId,
    });

    await this.setState({ vehicleSearchArray: allVehicles });

    const singleData = await this.companyStore.getCompanyDataById(
      this.props.companyId
    );

    await this.setState({
      companyId: getVehicleGroup.companyId,
      deviceGroupId: getVehicleGroup.deviceGroupId,
    });

    let vehicleData = [];
    getVehicleGroup.vehicles?.forEach((val) => {
      vehicleData.push(val.vehicleId);
    });

    if (vehicleData.length === allVehicles.length) {
      this.setState({ selectedChecked: true });
    }

    await this.setState({
      selectedValues: vehicleData,
      savedSelectedValues: vehicleData,
    });

    await this.formRef.current.setFieldsValue({
      deviceGroupId: getVehicleGroup.deviceGroupId,
      companyId: singleData,
      groupname: getVehicleGroup.groupname,
      inchargeName: getVehicleGroup.inchargeName,
      email: getVehicleGroup.email,
    });

    await this.setState({ loadingSpin: false });
  };

  onDeviceDetailsSubmit = async (values) => {
    this.setState({ loading: true });
    const data = {
      ...values,
      companyId: this.state.companyId,
      devicegroupId: this.state.deviceGroupId,
      deviceGroupparentId: 0,
      tokenId: "",
      vehicle: this.state.selectedValues,
      isSelectAll: this.state.selectedChecked,
    };
    const resp = await this.groupStore.addData(data);
    await this.setState({ savedSelectedValues: this.state.selectedValues });
    await this.props.response(resp);
    this.setState({ loading: false });
  };

  // CHANGE: Converted handleChange from regular async method to arrow function
  // — prevents losing `this` context when called from JSX onChange
  handleChange = async (comp) => {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleGroupId) {
      this.context.viewStateStore.setVehicleGroupStates({
        companyId: comp.value,
      });
    }
    // await this.formRef.current.setFieldsValue({ companyId: comp.value });

    const data = await this.groupStore.getAssetData({
      companyId: comp.value,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
    });
    this.setState({ vehicleSearchArray: data });
    // CHANGE: Removed broken handleSearch() call — used undefined currentPage/pageSize state
  };

  handleSelectAllChange = async (e) => {
    const checked = e.target.checked;
    this.setState({ selectedChecked: checked });

    if (checked) {
      const allValues = this.groupStore?.assetList.map(
        (option) => option.vehicleId
      );
      // CHANGE: Fixed bug — original code used `allValues.vehicleNo` (always undefined)
      // Now correctly passes the vehicleId array to selectedValues
      await this.setState({ selectedValues: allValues });
    } else {
      await this.setState({ selectedValues: [] });
    }
  };

  handleSingleCheckboxChange = async (e, vehicleId) => {
    const { checked } = e.target;
    let selectedValues = [...this.state.selectedValues];

    if (checked) {
      if (!selectedValues.includes(vehicleId)) {
        selectedValues.push(vehicleId);
      }
    } else {
      selectedValues = selectedValues.filter((id) => id !== vehicleId);
    }

    await this.setState({
      selectedValues,
      selectedChecked:
        selectedValues.length === this.groupStore.assetList.length,
    });
  };

  searchVehicles = async (searchValue) => {
    const lowerSearch = searchValue.toLowerCase();
    await this.groupStore.getAssetData({
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      search: lowerSearch,
    });
    return this.groupStore?.assetList?.filter(
      (vehicle) =>
        vehicle.vehicleNo &&
        vehicle.vehicleNo.toLowerCase().includes(lowerSearch)
    );
  };

  // CHANGE: Extracted vehicle search inline onChange into a named arrow method
  handleVehicleSearch = async (e) => {
    const searchValue = e.target.value;
    if (!searchValue) {
      await this.groupStore.getAssetData({
        companyId: this.state.companyId,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
      });
      this.setState({ vehicleSearchArray: this.groupStore.assetList });
      return;
    }
    const searchedArray = await this.searchVehicles(searchValue);
    this.setState({
      vehicleSearchArray:
        searchedArray?.length === 0 ? this.groupStore.assetList : searchedArray,
    });
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    const {
      selectedChecked,
      selectedValues,
      savedSelectedValues,
      vehicleSearchArray,
      loadingSpin,
      loading,
    } = this.state;

    return (
      <div style={{ padding: 0, height: "100%" }}>
        <Spin spinning={loadingSpin} wrapperClassName="spinClass" fullscreen>
          <Form
            layout="vertical"
            ref={this.formRef}
            onFinish={this.onDeviceDetailsSubmit}
            name="nest-message"
            className="formClass"
          >

            {/* ═══════════════════════════════════════════════════════
                BOX 1 — Form Fields
                Fields are in a 2-column grid inside one bordered box
                Account | Device Group | Email | Incharge Name
            ════════════════════════════════════════════════════════ */}
            {/* CHANGE: Was a flat Row with two Col(span=12) holding unboxed fields.
                Now wrapped in a single bordered box with all 4 fields in 2-col grid */}
            <div
              style={{
                // border: "1px solid #d9d9d9",
                // borderRadius: "6px",
                padding: "16px",
                marginBottom: "16px",
              }}
            >
              <Row gutter={16}>
                {(this.props.getUserData().isadmin === -1 ||
                  this.props.getUserData().isadmin === 3) && (
                    <Col span={12}>
                      <Form.Item
                        name="companyId"
                        label={
                          <span>
                            {this.context.translate("_ACCOUNT_")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate("_ACCOUNT_")} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          value={this.state.companyId}
                          onChange={this.handleChange}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  )}

                <Col span={12}>
                  <Form.Item
                    name="groupname"
                    label={
                      <span>
                        {this.context.translate("_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate("_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_")} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="email"
                    label={this.context.translate("_EMAIL_")}
                    rules={[
                      {
                        type: "email",
                        message: this.context.translate("_INVALID_EMAILID_"),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="inchargeName"
                    label={this.context.translate("_INCHARGE_NAME_")}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            {/* ═══════════════════════════════════════════════════════
                BOX 2 — Vehicle Selection (below Box 1)
                Search bar + Select All on top
                Scrollable vehicle checkbox list below
            ════════════════════════════════════════════════════════ */}
            {/* CHANGE: Vehicle section moved into its own bordered box below Box 1.
                Previously it was a floating div inside the same Row as form fields */}
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                padding: "16px",
                marginBottom: "16px",
                marginRight: "18px",
                marginLeft: "15px"
              }}
            >
              {/* Search + Select All row */}
              <Row gutter={8} align="middle">
                <Col span={10}>
                  <Input
                    size="small"
                    placeholder={
                      this.context.translate("_SEARCH_VEHICLES_") ||
                      "Search Vehicles"
                    }
                    onChange={this.handleVehicleSearch}
                    allowClear
                    style={{ fontSize: "12px" }}
                  />
                </Col>

                <Col span={4} style={{ textAlign: "center" }}>
                  <span style={{ fontSize: "12px", fontWeight: 500 }}>
                    Selected: {this.state.selectedValues?.length || 0}
                  </span>
                </Col>

                <Col
                  span={10}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                    {this.context.translate("_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_")}
                  </span>

                  <Checkbox
                    checked={selectedChecked}
                    onChange={this.handleSelectAllChange}
                    style={{ fontSize: "12px" }}
                  >
                    {this.context.translate("_ALL_")}
                  </Checkbox>
                </Col>
              </Row>
              <div style={{ fontSize: "11px", color: "#aaa", marginBottom: "8px" }}>
                {this.context.translate("_SELECT_ALL_NOTE_")}
              </div>

              {/* Scrollable vehicle list */}
              {vehicleSearchArray?.length > 0 && (
                <div
                  style={{
                    border: "1px solid #f0f0f0",
                    borderRadius: "4px",
                    padding: "10px",
                    height: "260px",
                    overflowY: "auto",
                  }}
                >
                  <Row gutter={[8, 8]}>
                    {/* CHANGE: Used .slice().sort() instead of .sort() directly
                        — avoids mutating the original vehicleSearchArray state array */}
                    {vehicleSearchArray
                      ?.slice()
                      .sort((a, b) => {
                        const aSelected = savedSelectedValues.includes(a.vehicleId);
                        const bSelected = savedSelectedValues.includes(b.vehicleId);
                        if (aSelected && !bSelected) return -1;
                        if (!aSelected && bSelected) return 1;
                        return 0;
                      })
                      .map((value) => (
                        <Col span={8} key={value.vehicleId}>
                          <Checkbox
                            checked={selectedValues.includes(value.vehicleId)}
                            onChange={(e) =>
                              this.handleSingleCheckboxChange(e, value.vehicleId)
                            }
                          >
                            {value.vehicleNo}
                          </Checkbox>
                        </Col>
                      ))}
                  </Row>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => {
                  this.closeModal();
                  this.setState({ selectedChecked: false, selectedValues: [] });
                }}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>
              <Button
                htmlType="submit"
                className="formsSaveButton"
                loading={loading}
              >
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </Spin>
      </div>
    );
  }
}

VehicleGroupAdd.contextType = StoreContext;
export default observer(withRouter(VehicleGroupAdd));




















// import React, { Component } from "react";
// import { Form, Button, Input, Checkbox, Row, Col, Spin } from "antd";
// import { observer } from "mobx-react";
// import { StoreContext } from "../store/RootStore";
// import VehicleGroupStore from "../store/VehicleGroupStore";
// import withRouter from "../withRouter";
// import CompanyAutocomplete from "./CompanyAutocomplete";
// import CompanyStore from "../store/CompanyStore";

// class VehicleGroupAdd extends Component {
//   formRef = React.createRef();

//   constructor(props) {
//     super(props);
//     this.state = {
//       loading: false,
//       selectedChecked: false,
//       selectedValues: [],
//       deviceGroupId: "",
//       companyId: "",
//       loadingSpin: false,
//       vehicleSearchArray: [],
//       savedSelectedValues: [],
//     };
//     this.groupStore = new VehicleGroupStore();
//     this.companyStore = new CompanyStore();
//   }

//   async componentDidMount() {
//     if (
//       Number(this.props.getUserData().isadmin) !== -1 &&
//       Number(this.props.getUserData().isadmin) !== 3
//     ) {
//       this.context.viewStateStore.setVehicleGroupStates({
//         companyId: this.props.getUserData().userCompanyId,
//       });
//       await this.setState({
//         companyId: this.props.getUserData().userCompanyId,
//         isadmin: this.props.getUserData().isadmin,
//       });
//       const data = await this.groupStore.getAssetData(
//         this.props.getUserData().userCompanyId
//       );
//       await this.setState({ vehicleSearchArray: data });
//     }

//     const deviceGroupId = this.props.vehicleGroupId;
//     if (deviceGroupId) {
//       await this.filldata(deviceGroupId);
//       await this.setState({ deviceGroupId });
//     }
//   }

//   filldata = async (deviceGroupId) => {
//     await this.setState({ loadingSpin: true });

//     const getVehicleGroup = await this.groupStore.getVehicleGroupData(
//       deviceGroupId,
//       this.props.companyId
//     );

//     const allVehicles = await this.groupStore.getAssetData({
//       companyId: this.props.companyId,
//     });

//     await this.setState({ vehicleSearchArray: allVehicles });

//     const singleData = await this.companyStore.getCompanyDataById(
//       this.props.companyId
//     );

//     await this.setState({
//       companyId: getVehicleGroup.companyId,
//       deviceGroupId: getVehicleGroup.deviceGroupId,
//     });

//     let vehicleData = [];
//     getVehicleGroup.vehicles?.forEach((val) => {
//       vehicleData.push(val.vehicleId);
//     });

//     if (vehicleData.length === allVehicles.length) {
//       this.setState({ selectedChecked: true });
//     }

//     await this.setState({
//       selectedValues: vehicleData,
//       savedSelectedValues: vehicleData,
//     });

//     await this.formRef.current.setFieldsValue({
//       deviceGroupId: getVehicleGroup.deviceGroupId,
//       companyId: singleData,
//       groupname: getVehicleGroup.groupname,
//       inchargeName: getVehicleGroup.inchargeName,
//       email: getVehicleGroup.email,
//     });

//     await this.setState({ loadingSpin: false });
//   };

//   onDeviceDetailsSubmit = async (values) => {
//     this.setState({ loading: true });
//     const data = {
//       ...values,
//       companyId: this.state.companyId,
//       devicegroupId: this.state.deviceGroupId,
//       deviceGroupparentId: 0,
//       tokenId: "",
//       vehicle: this.state.selectedValues,
//       isSelectAll: this.state.selectedChecked,
//     };
//     const resp = await this.groupStore.addData(data);
//     await this.setState({ savedSelectedValues: this.state.selectedValues });
//     await this.props.response(resp);
//     this.setState({ loading: false });
//   };

//   handleChange = async (comp) => {
//     await this.setState({ companyId: comp.value });
//     if (!this.props.vehicleGroupId) {
//       this.context.viewStateStore.setVehicleGroupStates({
//         companyId: comp.value,
//       });
//     }
//     await this.formRef.current.setFieldsValue({ companyId: comp.value });

//     const data = await this.groupStore.getAssetData({
//       companyId: comp.value,
//       isadmin: this.props.getUserData().isadmin,
//       userId: this.props.getUserData().userId,
//     });
//     this.setState({ vehicleSearchArray: data });
//   };

//   handleSelectAllChange = async (e) => {
//     const checked = e.target.checked;
//     this.setState({ selectedChecked: checked });

//     if (checked) {
//       const allValues = this.groupStore?.assetList.map(
//         (option) => option.vehicleId
//       );
//       await this.setState({ selectedValues: allValues });
//     } else {
//       await this.setState({ selectedValues: [] });
//     }
//   };

//   handleSingleCheckboxChange = async (e, vehicleId) => {
//     const { checked } = e.target;
//     let selectedValues = [...this.state.selectedValues];

//     if (checked) {
//       if (!selectedValues.includes(vehicleId)) {
//         selectedValues.push(vehicleId);
//       }
//     } else {
//       selectedValues = selectedValues.filter((id) => id !== vehicleId);
//     }

//     await this.setState({
//       selectedValues,
//       selectedChecked:
//         selectedValues.length === this.groupStore.assetList.length,
//     });
//   };

//   searchVehicles = async (searchValue) => {
//     const lowerSearch = searchValue.toLowerCase();
//     await this.groupStore.getAssetData({
//       companyId: this.state.companyId,
//       isadmin: this.props.getUserData().isadmin,
//       userId: this.props.getUserData().userId,
//       search: lowerSearch,
//     });
//     return this.groupStore?.assetList?.filter(
//       (vehicle) =>
//         vehicle.vehicleNo &&
//         vehicle.vehicleNo.toLowerCase().includes(lowerSearch)
//     );
//   };

//   handleVehicleSearch = async (e) => {
//     const searchValue = e.target.value;
//     if (!searchValue) {
//       await this.groupStore.getAssetData({
//         companyId: this.state.companyId,
//         isadmin: this.props.getUserData().isadmin,
//         userId: this.props.getUserData().userId,
//       });
//       this.setState({ vehicleSearchArray: this.groupStore.assetList });
//       return;
//     }
//     const searchedArray = await this.searchVehicles(searchValue);
//     this.setState({
//       vehicleSearchArray:
//         searchedArray?.length === 0
//           ? this.groupStore.assetList
//           : searchedArray,
//     });
//   };

//   closeModal = () => {
//     this.props.closeModal();
//   };

//   render() {
//     const { selectedChecked, selectedValues, savedSelectedValues, vehicleSearchArray, loadingSpin, loading } = this.state;

//     return (
//       <div style={{ padding: 0, height: "100%" }}>
//         <Spin spinning={loadingSpin} wrapperClassName="spinClass" fullscreen>
//           <Form
//             layout="vertical"
//             ref={this.formRef}
//             onFinish={this.onDeviceDetailsSubmit}
//             name="nest-message"
//             className="formClass"
//           >
//             {/* ─── Two-column layout ─── */}
//             <Row gutter={24} className="overflowFormInputs">

//               {/* ── LEFT BOX: Account / Group / Email / Incharge ── */}
//               <Col span={12}>
//                 <div
//                   style={{
//                     border: "1px solid #d9d9d9",
//                     borderRadius: "6px",
//                     padding: "16px",
//                   }}
//                 >
//                   {/* Account */}
//                   {(this.props.getUserData().isadmin === -1 ||
//                     this.props.getUserData().isadmin === 3) && (
//                     <Form.Item
//                       name="companyId"
//                       label={
//                         <span>
//                           {this.context.translate("_ACCOUNT_")}{" "}
//                           <span style={{ color: "red" }}>*</span>
//                         </span>
//                       }
//                       required={false}
//                       rules={[
//                         {
//                           required: true,
//                           message: `${this.context.translate("_ACCOUNT_")} ${this.context.translate("_IS_REQUIRED_")}`,
//                         },
//                       ]}
//                     >
//                       <CompanyAutocomplete
//                         value={this.state.companyId}
//                         onChange={this.handleChange}
//                         style={{ width: "100%" }}
//                       />
//                     </Form.Item>
//                   )}

//                   {/* Device Group */}
//                   <Form.Item
//                     name="groupname"
//                     label={
//                       <span>
//                         {this.context.translate("_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_")}{" "}
//                         <span style={{ color: "red" }}>*</span>
//                       </span>
//                     }
//                     required={false}
//                     rules={[
//                       {
//                         required: true,
//                         message: `${this.context.translate("_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_")} ${this.context.translate("_IS_REQUIRED_")}`,
//                       },
//                     ]}
//                   >
//                     <Input />
//                   </Form.Item>

//                   {/* Email */}
//                   <Form.Item
//                     name="email"
//                     label={this.context.translate("_EMAIL_")}
//                     rules={[
//                       {
//                         type: "email",
//                         message: this.context.translate("_INVALID_EMAILID_"),
//                       },
//                     ]}
//                   >
//                     <Input />
//                   </Form.Item>

//                   {/* Incharge Name */}
//                   <Form.Item
//                     name="inchargeName"
//                     label={this.context.translate("_INCHARGE_NAME_")}
//                   >
//                     <Input />
//                   </Form.Item>
//                 </div>
//               </Col>

//               {/* ── RIGHT BOX: Search Vehicle + Select All + Checkbox List ── */}
//               <Col span={12}>
//                 <div
//                   style={{
//                     border: "1px solid #d9d9d9",
//                     borderRadius: "6px",
//                     padding: "16px",
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "10px",
//                   }}
//                 >
//                   {/* Search input */}
//                   <Input
//                     placeholder={this.context.translate("_SEARCH_VEHICLES_") || "Search Vehicles"}
//                     onChange={this.handleVehicleSearch}
//                     allowClear
//                   />

//                   {/* Select All */}
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                     <span>
//                       {this.context.translate("_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_")}
//                     </span>
//                     <Checkbox
//                       checked={selectedChecked}
//                       onChange={this.handleSelectAllChange}
//                     >
//                       {this.context.translate("_ALL_")}
//                     </Checkbox>
//                   </div>

//                   <div style={{ fontSize: "12px", color: "#888" }}>
//                     Note: Selecting "All" will include all vehicles.
//                   </div>

//                   {/* Vehicle checkbox list */}
//                   <div
//                     style={{
//                       border: "1px solid #f0f0f0",
//                       borderRadius: "4px",
//                       padding: "10px",
//                       flex: 1,
//                       minHeight: "220px",
//                       maxHeight: "260px",
//                       overflowY: "auto",
//                     }}
//                   >
//                     <Row gutter={[8, 8]}>
//                       {vehicleSearchArray
//                         ?.slice()
//                         .sort((a, b) => {
//                           const aSelected = savedSelectedValues.includes(a.vehicleId);
//                           const bSelected = savedSelectedValues.includes(b.vehicleId);
//                           if (aSelected && !bSelected) return -1;
//                           if (!aSelected && bSelected) return 1;
//                           return 0;
//                         })
//                         .map((value) => (
//                           <Col span={12} key={value.vehicleId}>
//                             <Checkbox
//                               checked={selectedValues.includes(value.vehicleId)}
//                               onChange={(e) =>
//                                 this.handleSingleCheckboxChange(e, value.vehicleId)
//                               }
//                             >
//                               {value.vehicleNo}
//                             </Checkbox>
//                           </Col>
//                         ))}
//                     </Row>
//                   </div>
//                 </div>
//               </Col>
//             </Row>

//             {/* ─── Footer Buttons ─── */}
//             <div className="formFooter">
//               <Button
//                 className="formsCancelButton"
//                 onClick={() => {
//                   this.closeModal();
//                   this.setState({ selectedChecked: false, selectedValues: [] });
//                 }}
//               >
//                 {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
//               </Button>
//               <Button
//                 htmlType="submit"
//                 className="formsSaveButton"
//                 loading={loading}
//               >
//                 {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
//               </Button>
//             </div>
//           </Form>
//         </Spin>
//       </div>
//     );
//   }
// }

// VehicleGroupAdd.contextType = StoreContext;
// export default observer(withRouter(VehicleGroupAdd));